export const Envs = ['dev', 'prod', 'staging', 'devProd'] as const;
export type Env = typeof Envs[number];
